export const villaTypesState = {
    show: false,
    options: [
        {value: 'beach', label: 'ساحلی', checked: false},
        {value: 'forest', label: 'جنگلی', checked: false},
        {value: 'town', label: 'شهرکی', checked: false},
    ],
    selected_items: [],
};